<template>
    <v-select
        style="width: 33.3333%; display: inline-block"
        class="p-[5px]"
        :items="props.items"
        :item-value="props.itemValue"
        :item-text="props.itemText"
        :rules="props.rules"
        :label="props.label"
        :required="props.required"
        :disabled="props.disabled"
        v-model="selectedValue"
    ></v-select>
</template>

<script setup lang="ts">
    import { defineProps, computed, defineEmits } from 'vue'
    import { ValidationRule } from '@/model/types'

    type SelectItemKey = string | ((item: any) => string)

    const props = defineProps({
        modelValue: [String, Number, Object],
        items: Array,
        itemValue: {
            type: [String, Function] as unknown as unknown as unknown as () => SelectItemKey,
            default: 'value',
        },
        itemText: { type: [String, Function], default: 'text' },
        rules: {
            type: Array as () => ValidationRule[] | undefined,
            default: undefined,
        },
        label: String,
        required: Boolean,
        disabled: Boolean,
    })

    const emit = defineEmits(['update:modelValue'])

    const selectedValue = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val),
    })
</script>
